import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=881949da&scoped=true&"
import script from "./HomeComponent.vue?vue&type=script&lang=js&"
export * from "./HomeComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeComponent.vue?vue&type=style&index=0&id=881949da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881949da",
  null
  
)

export default component.exports